import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import gameUyility from './gameUtility';

import axios from 'axios';
// import VueAxios from 'vue-axios';
// import router from '../router';

// const errorHandler = (error) => {
//   if (error.response != null) {
//     if (error.response.status === 401) {
//       // window.localStorage.removeItem("krule_designer_user");
//       Vue.$ls.remove('access_token');
//       Vue.$ls.remove('user_info');
//       router.push({ path: 'login' });
//     }
//   }
//   return Promise.reject(error);
// };

// axios.interceptors.request.use((config) => {
//   const accToken = Vue.$ls.get('access_token');
//   if (accToken !== null && accToken !== undefined) {
//     config.headers.Authorization = `${accToken}`;
//   }
//   return config;
// }, (err) => {
//   return Promise.reject(err);
// });

// const successHandler = (response) => {
//   return response;
// };

// axios.interceptors.response.use(
//   (response) => successHandler(response),
//   (error) => errorHandler(error),
// );

Vue.use(Vuetify);
// Vue.use(VueAxios, axios);
Vue.use(axios);
Vue.use(require('vue-moment'));

import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const options = { lodash };
Vue.use(VueLodash, options);

import draggable from 'vuedraggable';
import DatetimePicker from 'vuetify-datetime-picker';
Vue.component('draggable', draggable);
Vue.use(gameUyility);

Vue.filter('capitalize', function(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
Vue.use(vueFilterPrettyBytes);
Vue.use(DatetimePicker);

import en from '@/locales/en';
import th from '@/locales/th';

export default new Vuetify({
  lang: {
    locales: { en, th },
    current: 'en',
  },
  icons: {
    iconfont: 'mdi',
  },
});
